import { AvatarState } from '@wix/aria-ai-avatar';

export type Position = {
  x: number;
  y: number;
};

type Keys = keyof typeof AvatarState;
export type AstroState = (typeof AvatarState)[Keys];

export type TimingConfig = {
  SHRINK_DURATION: number;
  UNDO_DURATION: number;
  TRAVEL_DURATION: number;
  PULSE_DURATION: number;
  PUBLISH_DURATION: number;
  IDEA_SPARK_DURATION: number;
  DELAY_BEFORE_MOVE: number;
  RETURN_TO_CHAT_DELAY: number;
  DEBOUNCE_DELAY: number;
  ANIMATION_FRAME_DELAY: number;
  BOREDOM_TIMEOUT: number;
  DOT_FADE_DURATION: number;
  BLINK_INTERVAL: number;
  BLINK_VARIATION: number;
  BLINK_MIN_INTERVAL: number;
};

export type AnimationConfig = {
  TRAIL_COUNT: number;
  TRAIL_STAGGER: number;
  TRAIL_FADE: number;
  TRAIL_MIN_SCALE: number;
  TRAIL_BLUR: number;
  DOT_SIZE: number;
  DOT_COLOR: string;
  SWAY_AMOUNT: number;
  CONTROL_POINT_1: number;
  CONTROL_POINT_2: number;
  EASING: string;
};
export type PositionFunction = () => Position;
export type PositionWithParamsFunction = (x: number, y: number) => Position;

export type AstroSize = {
  WIDTH: number;
  HEIGHT: number;
};

export type MoveOptions = {
  skipShrink?: boolean;
  endState?: AstroState;
};

export type AstroTrigger = {
  idle: () => Promise<void>;
  undo: () => Promise<void>;
  ideaSpark: () => Promise<void>;
  boredom: () => Promise<void>;
  bigLoader: () => Promise<void>;
  smallLoader: () => Promise<void>;
  shrink: () => Promise<void>;
  publish: () => Promise<void>;
};

export type AstroRef = {
  avatarHidden: boolean;
  getState: () => AvatarState;
  wrapper: HTMLDivElement | null;
  trigger: AstroTrigger;

  hide: (options?: { withDots?: boolean }) => void;
  show: () => void;
  onUserTyping: (caretX: number, caretY: number) => void;
  onTravelHomeFrom: (
    x: number,
    y: number,
    options?: MoveOptions,
  ) => Promise<void>;
  onTravelAwayTo: (
    x: number,
    y: number,
    options?: MoveOptions,
  ) => Promise<void>;

  changeAstroColor: (color: string) => void;
  toggleAvatarBackground: () => void;
  onMouseMove: (clientX: number, clientY: number) => void;
};

export type AstroProps = {
  mode?: 'light' | 'dark';
  variant?: '2d' | '3d';
};
